const LoaderPreDS = () => {
  return (
    <div className='container-loader'>
      <div className='spinner-border color-white' role='status'>
        <span className='visually-hidden'>...</span>
      </div>
    </div>
  );
};

export default LoaderPreDS;
